<template>
  <j-modal :okButtonProps="{ class:{'jee-hidden': disableSubmit} }" :ok-disabled=disableSubmit :title="title" :width="width" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" :okText="this.$store.getters.language['common.okButton']" @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :label-col="labelCol2" :wrapper-col="wrapperCol2"  :rules="validatorRules">
        <a-row>
        <!-- 场馆代码 -->
            <a-col :span="12">
        <a-form-model-item :label="language['cs.venuecode']" 
          prop="venuecode">
          <a-input v-model="model.venuecode" :placeholder="'系统自动生成'" :disabled="true"></a-input>
        </a-form-model-item>
      </a-col>
            <a-col :span="12">
        <!-- 场馆名称 -->
        <a-form-model-item :label="language['cs.venuename']" 
          prop="venuename">
          <a-input v-model="model.venuename" :placeholder="this.language['cs.venuename']" :maxLength="100"></a-input>
        </a-form-model-item>
            </a-col>
        <!-- 场馆状态 -->
        
        <a-col :span="12">
        <a-form-model-item :label="language['cs.venuestatus']" 
          prop="status">
          <j-dict-select-tag type="select" v-model="model.status" dictCode="cs_venuestatus" />
        </a-form-model-item>
      </a-col>
      
      <a-col :span="12">
        <!-- 场馆性质 -->
        <a-form-model-item :label="language['cs.venuecategory']" 
          prop="category">
          <j-dict-select-tag type="select" v-model="model.category" dictCode="cs_venuecategory" />
        </a-form-model-item>
      </a-col>
        </a-row>
        <a-row>
      <a-col :span="24">
        <!-- 场馆地址 -->
        <a-form-model-item :label="language['labor.contractor.detailAddress']" :labelCol="labelCol1"
          :wrapperCol="wrapperCol1" prop="address">
          <a-input v-model="model.address" :placeholder="this.language['labor.contractor.detailAddress']" :maxLength="500"></a-input>
        </a-form-model-item>
      </a-col>  </a-row>
        <a-row>
      <a-col :span="24">
        <!-- 上傳附件圖片 -->
        <a-form-model-item :label="this.language['common.uploadPicture']" :labelCol="labelCol1" :wrapperCol="wrapperCol1"
          prop="files">
          <j-image-upload class="avatar-uploader" text="上传"  v-model="model.files"
            :isMultiple="true" :disabled="disableSubmit"></j-image-upload>
        </a-form-model-item>
      </a-col>  </a-row>
      </a-form-model>

      <!-- 子表单区域 -->
      <a-tabs v-if="disableSubmit===false" v-model="activeKey" @change="handleChangeTabs">
        <a-tab-pane tab="樓層區域設置信息" :key="refKeys[0]" :forceRender="true">
          <j-editable-table 
          :ref="refKeys[0]" 
          :loading="children.loading" 
          :columns="columns"
          :dataSource="children.dataSource" 
          :maxHeight="400" 
          :maxNumber="100" 
          :disabled="formDisabled"
          :rowNumber="true" 
          :rowSelection="true" 
          @valueChange="valueChange"
          :actionButton="true" />
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </j-modal>
</template>
<script>

import { httpAction, getAction } from '@/api/manageChooseSeat'
import { validateDuplicateValue,hasValue} from '@/utils/util'
import { queryAreaIdTree } from '@/api/api'
import LanguageModel from "@/components/LanguageModel"
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED, validateFormModelAndTables } from '@/utils/JEditableTableUtil'
import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'


export default {
  name: "VenueModal",
  mixins: [JEditableTableModelMixin],
  components: {
    LanguageModel
  },
   //表单禁用
   disabled: {
        type: Boolean,
        default: false,
        required: false
      },
  data() {
    return {
      title: "操作",
      uploadSource:"chooseseat",
      width: 800,
      visible: false,
      disableSubmit:false,
      model: {},
      records: [],
      factoryOptions: [],
      areaTree: [],
       // form 一行布局
      labelCol1: { span: 4 },
      wrapperCol1: { span: 18 },
      // form 两行布局， 默认为两行
      labelCol2: { span: 8 },
      wrapperCol2: { span: 12 },

      confirmLoading: false,
      url: {
        add: "/venueinfo/addData",
        edit: "/venueinfo/editData",
      },
      expandedRowKeys: [],
      pidField: "pid",
      areaNameLanguages: [],


      // 新增时子表默认添加几行空数据
      addDefaultRowNum: 1,
      refKeys: ['venueinfoList',],
      tableKeys: ['venueinfoList',],
      activeKey: 'venueinfoList',
      // fm_firm_site_line
      children: {
        loading: false,
        dataSource: [],
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    formDisabled() {
      return this.disabled
    },
    validatorRules() {
      if (this.language) {
        return {
          venuename: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['cs.venuename'] },
          ],
          status: [
            { required: true, message: this.language['cs.input'] + this.language['cs.venuestatus'] },
          ],
          category: [
            { required: true, message: this.language['common.select'] + this.language['cs.venuecategory'] },
          ],
          address: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['labor.contractor.detailAddress'] },
          ],

        }
      }
    },
    columns() {
        if (this.language) {
          return[
            {
              title: this.language['cs.floorcode'],
              key: 'floorcode',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.language['cs.floorname'],
              key: 'floorname',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              defaultValue:'',
              validateRules: [{ required: true, message: '${title}不能为空' }],
            },
            {
              title: this.language['cs.areacount'],
              key: 'areacount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: this.language['cs.maxlineofarea'],
              key: 'maxlineofarea',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
              title: this.language['cs.maxcolumnofarea'],
              key: 'maxcolumnofarea',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            {
            title: this.language['cs.uploadfloorimage'] ,
            key: 'files',
            type: FormTypes.file,
            token:true,
            responseName:"message",
            width:"200px",
            placeholder: this.language['common.pleaseInput']+this.language['common.file'],
            defaultValue:'',
            validateRules: [{ required: false, message: this.language['fd.input'] + '${title}' }],
          },
            {
              title: this.language['cs.seat.seattotalqty'],
              key: 'seatcount',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.language['fd.input']+'${title}',
              disabled:true,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
          
          ]

          }
        }
  },
  created() {
    //  this.initFactoryList();
  },
  methods: {
    languageModelOpen(dataTable, dataColumn, languagelist) {
      this.$refs.languageModel.edit("platform", dataTable, dataColumn, this.model.id, languagelist, this.disableSubmit);
    },
    languageOk(map) {
      if (map && map.dataColumn == 'areaName') {
        this.areaNameLanguages = map.languagelist;
      }
    },
    initLanguagetemp(dataTable, dataColumn, dataId) {
      getAction("/sys/syslanguagedata/querylistby", {
        applicationCode: "platform",
        dataTable: dataTable,
        dataColumn: dataColumn,
        dataId: dataId
      }).then((res) => {
        if (res.success) {
          this.areaNameLanguages = res.result;
        }
      })
    },
    add() {
      this.visible = true;
      this.model= {};
    },
    edit(record) {
      this.visible = true;
      this.model = {}
      this.model = Object.assign({}, record);
    },

    loadTreeData() {
      var that = this;
      queryAreaIdTree().then((res) => {
        if (res.success) {
          that.areaTree = [];
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i];
            that.areaTree.push(temp);
          }
        }

      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.$refs.form.clearValidate()
    },


    valueChange(e) {
      let { type, row, column, value, target } = e
      var tab = this.$refs[this.refKeys[0]]
     
      // 重新计算值
      if (column.key === 'areacount'||column.key === 'maxlineofarea'||column.key === 'maxcolumnofarea') {
        this.computeValue(row, tab)
      }
      // this.refreshValidate()
    },
    // 重新计算值
    computeValue(row, tab) {
      let seatcount = 0
      let areacount =  row.areacount
      let maxlineofarea = row.maxlineofarea
      let maxcolumnofarea= row.maxcolumnofarea

      if (hasValue(areacount)&&hasValue(maxlineofarea)&&hasValue(maxcolumnofarea)) {
        // 座位数=区域数*行数*列数
        seatcount = areacount * maxlineofarea*maxcolumnofarea
        
      }
  
      tab.setValues([{ rowKey: row.id, values: { seatcount } }])
      this.refreshValidate()
    },


    refreshValidate() {
      var tab = this.$refs[this.activeKey]
      if (tab) {
        tab.getValuesSync(true)
      }
    },

    send(formData) {
      const that = this;
      that.confirmLoading = true;
      let httpurl = '';
      let method = '';
      if (!this.model.sysvenueid) {
        httpurl += this.url.add;
        method = 'post';
      } else {
        httpurl += this.url.edit;
        method = 'put';
      }

      httpAction(httpurl, this.model, method).then((res) => {
        if (res.success) {
          that.model = {};
          that.$message.success(res.message);
          that.confirmLoading = false;
          that.close();
          that.$emit('ok');

        } else {
          that.$message.warning(res.message);
          that.confirmLoading = false;
        }
      }).finally(() => {
        that.confirmLoading = false;
      })

    },
    handleCancel() {
      this.close();
    },
    submitSuccess(formData, flag) {
      if (!formData.id) {
        let treeData = this.$refs.treeSelect.getCurrTreeData()
        this.expandedRowKeys = []
        this.getExpandKeysByPid(formData[this.pidField], treeData, treeData)
        this.$emit('ok', formData, this.expandedRowKeys.reverse());
      } else {
        this.$emit('ok', formData, flag);
      }
    },
    getExpandKeysByPid(pid, arr, all) {
      if (pid && arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].key == pid) {
            this.expandedRowKeys.push(arr[i].key)
            this.getExpandKeysByPid(arr[i]['parentId'], all, all)
          } else {
            this.getExpandKeysByPid(pid, arr[i].children, all)
          }
        }
      }
    },

    //
    factoryChange(val) {
      this.records.forEach((vm) => {

        if (vm.id == val) {
          this.model.areaCode = vm.factoryCode;
          this.model.areaName = vm.factoryName;
        }
      })


    },

    //初始化厂区字典
    initFactoryList() {
      let para = { pageNo: 1, pageSize: 1000 };
      getAction(this.url.queryFactoryList, para).then(res => {
        if (res.success) {
          this.records = res.result.records;
          this.factoryOptions = res.result.records.map((item, index, arr) => {
            let c = { label: item.factoryName, value: item.id + "" }
            return c;
          })
        }
      })
    },


    
    /** 整理成formData */
    classifyIntoFormData(allValues) {
      let main = Object.assign(this.model, allValues.formValue)
      return {
        ...main, // 展开
        children: allValues.tablesValue[0].values
      }
    },
  }
}
</script>